import { render, staticRenderFns } from "./ContactSort.vue?vue&type=template&id=422d6025&"
import script from "./ContactSort.vue?vue&type=script&lang=ts&"
export * from "./ContactSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports